import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

/** Header to bypass this interceptor when present on a request. */
export const InterceptSkipErrorHeader = 'X-Skip-Error-Interceptor';

/**
 * Intercepts HTTP responses with Blob error bodies and rethrows a parsed JSON error.
 *
 * Some endpoints return errors as `Blob`. This interceptor reads the blob, tries to
 * parse JSON, and re-creates an `HttpErrorResponse` with the parsed error payload.
 * Requests can opt-out by setting the `X-Skip-Error-Interceptor` header.
 */
@Injectable({
  providedIn: 'root',
})
export class BlobHttpErrorInterceptorService implements HttpInterceptor {
  constructor() {
  }

  // https://stackoverflow.com/a/49047764
  /**
   * Attempts to convert Blob error bodies into structured JSON errors.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(InterceptSkipErrorHeader)) {
      const headers = req.headers.delete(InterceptSkipErrorHeader);
      return next.handle(req.clone({headers}));
    }
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.error instanceof Blob) {
          return new Promise<any>((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = (e) => {
              try {
                reject(new HttpErrorResponse({
                  error: JSON.parse(e.target.result as string),
                  headers: error.headers,
                  status: error.status,
                  statusText: error.statusText,
                  url: error.url || undefined,
                }));
              } catch (e) {
                reject(error);
              }
            };
            fr.onerror = (_) => {
              reject(error);
            };
            fr.readAsText(error.error);
          });
        }
        throw error;
      }),
    );
  }

}
